import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import { Button, Text } from 'modules/common';

function FormCreateButtons({
  primaryButtonProps,
  isInsidePageHeader,
  onCancel,
  onSubmit,
  isLoading,
  disabled,
  actionButtonProps,
  secondaryButtonProps,
  withActionButton,
  actionDescription,
  isAlignLeft,
  withCancel,
  containerClassName,
}) {
  return (
    <div
      className={cn('flex items-center gap-ds-8', containerClassName, {
        'flex-1': isInsidePageHeader,
      })}
    >
      {withActionButton && (
        <div className="flex items-center gap-x-1.5 flex-1 flex-wrap">
          {actionDescription && (
            <Text type="caption" color="muted">
              {actionDescription}
            </Text>
          )}

          <Button
            label="Action here"
            variant="text"
            type="secondary"
            className="-ml-1"
            {...actionButtonProps}
          />
        </div>
      )}

      <div
        className={cn('flex items-center gap-ds-8', {
          'flex-1': isInsidePageHeader,
          'ml-auto': isAlignLeft,
        })}
      >
        {withCancel && (
          <Button
            label="Cancel"
            onClick={onCancel}
            disabled={disabled}
            isLoading={isLoading}
            {...secondaryButtonProps}
            className={cn(
              {
                'flex-1': isInsidePageHeader,
              },
              secondaryButtonProps?.className
            )}
          />
        )}

        <Button
          label="Submit"
          type="primary"
          onClick={onSubmit}
          withScrollOnError
          disabled={disabled}
          isLoading={isLoading}
          {...primaryButtonProps}
          className={cn(
            {
              'flex-1': isInsidePageHeader,
            },
            primaryButtonProps?.className
          )}
        />
      </div>
    </div>
  );
}

FormCreateButtons.defaultProps = {
  primaryButtonProps: {},
  actionButtonProps: {},
  secondaryButtonProps: {},
  isInsidePageHeader: false,
  isLoading: false,
  disabled: false,
  withActionButton: false,
  isAlignLeft: false,
  withCancel: true,
  onSubmit: () => {},
  onCancel: () => {},
  actionDescription: 'Want something done?',
  containerClassName: '',
};

FormCreateButtons.propTypes = {
  containerClassName: PropTypes.string,
  primaryButtonProps: PropTypes.instanceOf(Object),
  actionButtonProps: PropTypes.instanceOf(Object),
  secondaryButtonProps: PropTypes.instanceOf(Object),
  isInsidePageHeader: PropTypes.bool,
  isLoading: PropTypes.bool,
  withActionButton: PropTypes.bool,
  isAlignLeft: PropTypes.bool,
  withCancel: PropTypes.bool,
  disabled: PropTypes.bool,
  actionDescription: PropTypes.string,
  onCancel: PropTypes.instanceOf(Function),
  onSubmit: PropTypes.instanceOf(Function),
};

export default FormCreateButtons;
